import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const duplicateEmailTemplate = async (uuid: string, name: string) => {
  const response = await CustomAxios.post(`/email_templates/${uuid}/duplicate_template`, {
    uuid,
    name,
  });
  return response.data;
};

interface DuplicateEmailTemplateInput {
  uuid: string;
  name: string;
}

export function useDuplicateEmailTemplate(onSuccessCallback: (newUuid: string) => void) {
  return useMutation({
    mutationFn: ({ uuid, name }: DuplicateEmailTemplateInput) => duplicateEmailTemplate(uuid, name),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEmailTemplates] });
      onSuccessCallback(data.uuid);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to duplicate the email template. Please try again and contact support if the problem persists.');
      }
    },
  });
}
